import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';

// True inside the iOS / Android app (Capacitor WebView), false in a browser.
export const isNativeApp = () => Capacitor.isNativePlatform();

export const nativePlatform = () => Capacitor.getPlatform(); // 'ios' | 'android' | 'web'

// Licences are bought and accounts opened on the website only: the store
// apps may not sell digital services or point to an outside checkout
// (App Store 3.1.1 / 3.1.3(b)), so their links and pages stay out of the app.
export const canBuyInApp = () => !isNativeApp();

// Call `fn` whenever the app comes back to the foreground. Returns a cleanup
// function. No-op in the browser.
export const onAppResume = (fn) => {
  if (!isNativeApp()) return () => {};
  const handle = CapacitorApp.addListener('appStateChange', ({ isActive }) => {
    if (isActive) fn();
  });
  return () => {
    Promise.resolve(handle).then((h) => h?.remove?.()).catch(() => {});
  };
};

// One-time setup for the native shell. No-op in the browser.
export const initNativeApp = () => {
  if (!isNativeApp()) return;
  document.documentElement.classList.add('native-app', `native-${nativePlatform()}`);

  // Android hardware back button: go back in the app's history, and only
  // leave the app from its first screen (the default would exit right away).
  CapacitorApp.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) {
      window.history.back();
    } else {
      CapacitorApp.exitApp();
    }
  });
};
